import { Component, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'smrts-item-menu',
  templateUrl: './item-menu.component.html',
  styleUrls: ['./item-menu.component.scss'],
  standalone: false
})
export class ItemMenuComponent {
  @Input() disabled: boolean;

  @Input() url: string;

  @Input() text: string;

  @Input() icon: string;

  @Input() menuDrawer: MatDrawer;

  isCustomIcon(icon: string): boolean {
    return icon.indexOf('custom:') >= 0;
  }
}
